export function removeSystemUsersFromUserDisplayNameMap(
  userDisplayNamesMap: Record<string, string>,
): Record<string, string> {
  const filteredMap = Object.entries(userDisplayNamesMap).filter(
    ([key, _]) => key !== "server" && key !== "customer",
  );
  return Object.fromEntries(filteredMap);
}
